export enum DefaultViewTemplate {
  Colorless = 16,
  Fancy = 17,
  Rough = 15,
  // fixme figure out why it is duplicated and fix
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Jewelry = 15,
  ColorlessEdit = 18,
  FancyEdit = 19,
  RoughEdit = 20,
  // fixme figure out why it is duplicated and fix
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  JewelryEdit = 20,
  Gem = 21,
  GemEdit = 22,
}
